import * as types from '../types';

export const updateState = state => ({
    type: types.NOTIFICATIONS_UPDATE_STATE,
    payload: state
});

export const resetState = () => ({
    type: types.NOTIFICATIONS_RESET_STATE
});
